import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Stagiaire } from './stagiaire';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class GestionStagiairesService {

  private domaine: String = 'http://10.1.5.45:8000/groupC/stagiaire/';

  constructor(
    private http: Http
  ) { }

  public addNewStagiaire(newStagiaire: Stagiaire) {
    console.log('Add new Stagiaire ' + newStagiaire.nom + ' ' + newStagiaire.prenom + ' ' 
                + newStagiaire.entreprise.id + ' ' + newStagiaire.sujet.idSu);
    return this.http
          .post(this.domaine + 'addNewStagiaire', newStagiaire)
          .map(res => res.json());
  }

  public loadStagiaires(): Observable<Stagiaire[]> {
    console.log('Get Stagiaires ');
    return this.http
          .get(this.domaine + 'getAll')
          .map((res: Response) => <Stagiaire[]>res.json());
  }

  public updateStagiaire(stagiaire: Stagiaire) {
    console.log('Update Stagiaire ' + stagiaire.nom + ' ' + stagiaire.prenom);
    return this.http
          .put(this.domaine + 'update', stagiaire)
          .map(res => res.json());
  }

  public deleteStagiaire(id: Number) {
    console.log('Delete Stagiaire ' + id);
    return this.http.delete(this.domaine + 'delete/' + id)
          .map(res => res.json());
  }

  public getStagiaireById(id: Number): Observable<Stagiaire> {
    console.log('Get Stagiaire ' + id);
    return this.http
          .get(this.domaine + 'getStagiaireById/' + id)
          .map((res: Response) => <Stagiaire>res.json());
  }
}



// WEBPACK FOOTER //
// C:/Users/Yassine/Desktop/gestion-stagiaires/src/app/gestion-stagiaires/gestion-stagiaires.service.ts